import { useCallback, useEffect, useMemo, useState } from "react";

import { useAuth } from "./auth";
import { useSinalario, type DataTypeVerbete } from "./sinalario";

export type GameWord = DataTypeVerbete & {
  isFromPersonalRepository?: boolean;
};

function shuffle<T>(arr: T[]): T[] {
  const a = [...arr];
  for (let i = a.length - 1; i > 0; i -= 1) {
    const j = Math.floor(Math.random() * (i + 1));
    [a[i], a[j]] = [a[j], a[i]];
  }
  return a;
}

export function useGameWords(limit = 12) {
  const { getVerbete } = useSinalario();
  const { user } = useAuth();
  const [all, setAll] = useState<GameWord[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      setLoading(true);
      try {
        const list = await getVerbete();
        if (!cancelled) {
          setAll(
            (list || []).filter(
              (v) => v?.palavra?.trim() && (v.video || v.image)
            )
          );
        }
      } catch {
        if (!cancelled) setAll([]);
      } finally {
        if (!cancelled) setLoading(false);
      }
    })();
    return () => {
      cancelled = true;
    };
  }, [getVerbete]);

  const pickWords = useCallback(
    (count = limit) => shuffle(all).slice(0, Math.min(count, all.length)),
    [all, limit]
  );

  const words = useMemo(() => pickWords(limit), [pickWords, limit]);

  return { words, all, pickWords, loading, user };
}

export { shuffle };
